import { render, staticRenderFns } from "./merchantBindReview.vue?vue&type=template&id=39f1b311&"
import script from "./merchantBindReview.vue?vue&type=script&lang=js&"
export * from "./merchantBindReview.vue?vue&type=script&lang=js&"
import style0 from "./merchantBindReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports